import cn from 'classnames';
import { FC } from 'react';
import { FormattedDate } from 'react-intl';

import styles from './RecordingsDayLabel.module.scss';

type RecordingsDayLabelProps = {
  date: Date;
  className?: string;
};

export const RecordingsDayLabel: FC<RecordingsDayLabelProps> = ({
  date,
  className,
}) => (
  <div className={cn(styles.container, className)}>
    <span className={cn('h5', styles.day)}>
      <FormattedDate value={date} month="short" day="numeric" />
    </span>
    <span className={cn('p3', styles.year)}>
      <FormattedDate value={date} year="numeric" />
    </span>
  </div>
);
